import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { RoleBaseComponent } from './role-base/role-base.component';
import { CweRateComponent } from './cwe-rate/cwe-rate.component';

@Component({
    selector: 'role-information',
    standalone: true,
    imports: [ButtonModule, TabsModule, RoleBaseComponent, CweRateComponent],
    templateUrl: './role-information.component.html',
    styleUrl: './role-information.component.less',
})
export class RoleInformationComponent {
    isHome: boolean = true;
}
